import React from "react";
import { getPromoConfig } from "../utils/promo";

/**
 * Banner shown once after sign-in when the user arrived via a promo QR/link.
 * Dismissible. Persistence of "already seen" is handled by the parent via
 * markBannerSeen() in utils/promo.js.
 */
export default function PromoBanner({ source, onDismiss }) {
  const config = getPromoConfig(source);
  if (!config) return null;

  return (
    <div
      role="status"
      style={{
        position: "relative",
        zIndex: 9997,
        background: "linear-gradient(90deg,#0a2a5e,#1a5fbf)",
        borderBottom: "1px solid rgba(96,165,250,0.45)",
        color: "#fff",
        padding: "12px 40px 12px 16px",
        fontSize: 13,
        lineHeight: 1.45,
        letterSpacing: 0.3,
        fontWeight: 600,
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>{config.bannerMessage}</div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        style={{
          background: "transparent",
          border: "none",
          color: "#fff",
          cursor: "pointer",
          fontSize: 22,
          lineHeight: 1,
          padding: 0,
          position: "absolute",
          top: 8,
          right: 12,
        }}
      >
        ×
      </button>
    </div>
  );
}
